import React, { useState, useEffect } from "react";
import Navbar from "../../Components/Navbar";
import { fetchProfile } from "../../utils/fetchProfile";
import { dataStatModules } from "../../utils/constant";
import Cookies from "js-cookie";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import EditIcon from "@mui/icons-material/Edit";
import { Slide, toast } from "react-toastify";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Tooltip,
  IconButton,
  Modal,
  Box,
  Autocomplete,
  Grid,
} from "@mui/material";
import "../../style/setup.css";
import { ModalConfirmation } from "../../Components/Fragments/Modals/ModalGeneral";

const tableCellStyle = {
  whiteSpace: "nowrap",
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  color: "#FFF",
  fontWeight: "bold",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  minWidth: 120,
  textAlign: "center",
};

const BootstrapButton = styled(Button)({
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  border: "1px solid hsl(186, 89.90%, 27.30%)",
  borderRadius: "4px",
  color: "#fff",
  fontSize: { xs: "14px", sm: "16px" },
  padding: "4px 10px",
  textTransform: "none",
  "&:hover": {
    backgroundImage: "linear-gradient(#0991a2, #057d8c)",
  },
});

function SetupBpsDistrict() {
  const accessToken = Cookies.get("access_token") || "";

  const [sortBy, setSortBy] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const itemsPerPageList = [5, 10, 50, 100];
  const [totalItems, setTotalItems] = useState("");

  const [filterColumnValue, setFilterColumnValue] = useState("");

  const [dataProfile, setDataProfile] = useState([]);
  const [dataProvinces, setDataProvinces] = useState([]);
  const [dataRegencies, setDataRegencies] = useState([]);
  const [dataRegenciesTemp, setDataRegenciesTemp] = useState([]);

  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedRegency, setSelectedRegency] = useState("");

  const [filteredRows, setFilteredRows] = useState([]);
  const [searchBarValue, setSearchBarValue] = useState("setup-bps-district");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [editDataId, setEditDataId] = useState(null);
  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [openDialogConfirmationExport, setOpenDialogConfirmationExport] = useState(false);
  const [viewDataExport, setViewDataExport] = useState({
    title: null,
    process_at: null,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, [
        "13",
        "14",
        "TL",
        "COA",
        "A",
      ]);
      fetchProvince();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchRegency();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [selectedProvince]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (editedData.province_id) {
        fetchRegencyForAction();
      } else setDataRegenciesTemp([]);
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [editedData.province_id]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchMainData();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [
    accessToken,
    currentPage,
    itemsPerPage,
    selectedProvince,
    selectedRegency,
    sortBy, 
    sortOrder
  ]);

  async function fetchProvince() {
    const token = Cookies.get("access_token");

    setDataProvinces([]);
    setIsLoading(true);

    const queryParams = new URLSearchParams();

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/province` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: item.name,
          value: item.code,
        }));
        setDataProvinces(newArray);
        // setSelectedProvince(data[0].code);
      } else {
        setDataProvinces([]);
      }
    } catch (error) {
      setDataProvinces([]);
    }
    setIsLoading(false);
  }

  async function fetchRegency() {
    if (selectedProvince) {
      const token = Cookies.get("access_token");

      setDataRegencies([]);
      setIsLoading(true);

      const queryParams = new URLSearchParams();

      queryParams.append("province_code", selectedProvince);

      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/regency` +
        (queryString ? `?${queryString}` : "");

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const { data } = await response.json();
          const newArray = data.map((item) => ({
            label: item.name,
            value: item.code,
          }));
          setDataRegencies(newArray);
          // setSelectedRegency(data[0].code);
        } else {
          setDataRegencies([]);
        }
      } catch (error) {
        setDataRegencies([]);
      }
      setIsLoading(false);
    }
  }

  async function fetchRegencyForAction() {
    const token = Cookies.get("access_token");

    setDataRegenciesTemp([]);

    const queryParams = new URLSearchParams();

    queryParams.append(
      "province_code",
      editedData.province_id
    );

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/regency` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: item.name,
          value: item.code,
        }));
        setDataRegenciesTemp(newArray);
      } else {
        setDataRegenciesTemp([]);
      }
    } catch (error) {
      setDataRegenciesTemp([]);
    }
  }

  async function fetchMainData(customParams = filterColumnValue) {
    const token = Cookies.get("access_token");

    setFilteredRows([]);
    setIsLoading(true);

    const queryParams = new URLSearchParams();

    if (selectedProvince) {
      queryParams.append("province_code", selectedProvince);
    }

    if (selectedRegency) {
      queryParams.append("regency_code", selectedRegency);
    }

    queryParams.append("page", currentPage);
    queryParams.append("size", itemsPerPage);
    queryParams.append("sort_by", sortBy);
    queryParams.append("sort_order", sortOrder);

    if (customParams) {
      queryParams.append("column_value", customParams);
      queryParams.append("column_operator", "LIKE");
    }

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/district` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setTotalItems(data.pagination_info.total);
        setFilteredRows(data.data);
      } else {
        setFilteredRows([]);
      }
    } catch (error) {
      setFilteredRows([]);
    }

    setIsLoading(false);
  }

  const handleTableSelection = (newValue) => {
    if (newValue) {
      setSearchBarValue(newValue.value);
      setTimeout(() => {
        window.location.href = newValue.value;
      }, 100);
    }
  };

  const handleProvinceChange = (newValue) => {
    if (newValue) {
      setSelectedProvince(newValue.value);
      setSelectedRegency("");
      setCurrentPage(1);
    } else {
      setSelectedProvince("");
      setSelectedRegency("");
      setCurrentPage(1);
    }
  };

  const handleRegencyChange = (newValue) => {
    if (newValue) {
      setSelectedRegency(newValue.value);
      setCurrentPage(1);
    } else {
      setSelectedRegency("");
      setCurrentPage(1);
    }
  };

  const handleEditClick = async (row) => {
    setEditedData({
      province_id: row.province_code,
      regency_id: row.regency_code,
      name: row.name,
    });
    setEditDataId(row.id);
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setEditedData({});
  };

  const handleUpdateData = async () => {
    setIsLoading(true);
    if (editDataId) {
      const token = Cookies.get("access_token");
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/district/${editDataId}`,
          {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(editedData),
          }
        );

        if (response.status === 200) {
          toast.success("Data berhasil diubah!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
          setEditModalOpen(false);
          setFilterColumnValue("");
          setCurrentPage(1);
          await fetchMainData("");
        } else if (response.status == 422) {
          toast.error("Data gagal diproses!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        } else {
          const data = await response.json();
          toast.error(data.detail || "Data gagal diubah!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
    setIsLoading(false);
  };

  const handleResetFilter = () => {
    setFilterColumnValue("");
    setSelectedProvince("");
    setSelectedRegency("");
    setCurrentPage(1);
    fetchMainData(""); 
  };

  const handleSearch = (e) => {
    e.preventDefault();

    setCurrentPage(1);
    fetchMainData();
  };

  const handleProcessExport = async () => {
    setIsLoading(true);
    const token = Cookies.get("access_token");
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/process_queue/stat_module`;

    const body = {
      title: "Stat Module - Setup BPS Kecamatan",
      setup: "district",
      province_code: selectedProvince || null,
      regency_code: selectedRegency || null,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (response.ok) {
        toast.success("Data akan diproses kedalam antrian.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        const data = await response.json();
        toast.error(data.detail || "Gagal memulai proses export!", {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } catch (error) {
      toast.error("Terjadi kesalahan jaringan saat memulai proses export.");
    }
    setIsLoading(false);
  };

  const handleConfirmationExport = async () => {
    setIsLoading(true);

    const setup = "district";

    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/process_queue/stat_module/${setup}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (response.status === 200) {
      const { data } = await response.json();
      setOpenDialogConfirmationExport(true);
      setViewDataExport({
        title: data.data.title ?? "stat module - export result",
        process_at: data.process_at,
      });
    } else if (response.status === 400 || response.status === 404) {
      const { detail } = await response.json();
      toast.error(detail || "Data sedang diproses", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    } else {
      const { detail } = await response.json();
      toast.error(detail || "Tidak ditemukan excel, klik Process terlebih dahulu", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    }
    setIsLoading(false);
  };

  const handleCloseConfirmationExport = () => {
    setOpenDialogConfirmationExport(false);
    // clear data
    setViewDataExport({
      title: "",
      process_at: "",
    });
  };

  const handleExportResult = async () => {
    setIsLoading(true);
    try {
      const queryParams = new URLSearchParams();

      const setup = "district";

      // Construct the full URL with query parameters
      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/process_queue/stat_module/export/${setup}` +
        (queryString ? `?${queryString}` : "");

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status === 200) {
        const blob = await response.blob();
        const filename = `${viewDataExport.title || "stat module - export result"}.xlsx`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        handleCloseConfirmationExport();
      } else if (response.status === 400 || response.status === 404) {
        const data = await response.json();
        toast.error(data.detail, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        toast.error('Gagal mengunduh', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        console.error('Failed to export process queue:', response.statusText);
      }
    } catch (error) {
      console.error('Error export process queue:', error);
    }
    setIsLoading(false);
  };

  // pagination
  const handlePageChange = (event, page) => {
    setCurrentPage(page + 1);
  };

  const handleChangeItemPerPageSelect = (e) => {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  };

  // sorting
  const handleSort = (column) => {
    const isSorting = sortBy === column && sortOrder === "asc";
    setSortOrder(isSorting ? "desc" : "asc");
    setSortBy(column);
  };

  const sortTableCell = (label, sortByKey) => (
    <TableCell style={tableCellStyle} sx={{ border: 1, borderColor: 'grey.300' }}>
      <TableSortLabel
        active={sortBy === sortByKey}
        direction={sortOrder}
        onClick={() => handleSort(sortByKey)}
        sx={{
          color: "#FFF !important",
          "&:hover": {
            color: "#FFF",
          },
          "& .MuiTableSortLabel-icon": {
            color: "#FFF !important",
          },
        }}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );

  if (notAllowAccessPage) {
    return (
      <div>
        <Navbar
          active="Stat Module"
          initial={dataProfile.initial}
          role_code={dataProfile.role_code}
        />
        <div>Not allowed to access this page</div>
      </div>
    );
  }

  return (
    <div>
      <Navbar
        active="Stat Module"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <div style={{ padding: "1rem" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: "10px",
            marginBottom: "15px",
          }}
        >
          <Grid container spacing={0.5}>
            <Grid item xs="auto" sm="auto">
              <Autocomplete
                options={dataStatModules}
                getOptionLabel={(option) => option.label}
                value={
                  dataStatModules.find(
                    (option) => option.value === searchBarValue
                  ) || null
                }
                onChange={(e, newValue) => handleTableSelection(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cari Kategori"
                    size="small"
                    style={{ width: "300px" }}
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                disableClearable
              />
            </Grid>
            <Grid item xs="auto" sm="auto">
              <Autocomplete
                options={dataProvinces}
                getOptionLabel={(option) => option.label}
                value={
                  dataProvinces.find(
                    (option) => option.value === selectedProvince
                  ) || null
                }
                onChange={(e, newValue) => handleProvinceChange(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Pilih Provinsi"
                    size="small"
                    style={{ width: "300px" }}
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </Grid>
            <Grid item xs="auto" sm="auto">
              <Autocomplete
                options={dataRegencies}
                getOptionLabel={(option) => option.label}
                value={
                  dataRegencies.find(
                    (option) => option.value === selectedRegency
                  ) || null
                }
                onChange={(e, newValue) => handleRegencyChange(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Pilih Kab/Kota"
                    size="small"
                    style={{ width: "300px" }}
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </Grid>
            <Grid item xs="auto" sm="auto">
              <form
                onSubmit={handleSearch}
                style={{ display: "flex", alignItems: "center" }}
              >
                <TextField
                  sx={{
                    mr: 0.5,
                    height: 40,
                  }}
                  name="column_value"
                  label="Cari"
                  size="small"
                  value={filterColumnValue}
                  onChange={(e) => {
                    setFilterColumnValue(e.target.value);
                  }}
                />
                <BootstrapButton
                  variant="contained"
                  disableRipple
                  sx={{ width: 120, height: 40 }}
                  type="submit"
                  disabled={isLoading || !filterColumnValue}
                >
                  {isLoading ? "Loading..." : "Cari"}
                </BootstrapButton>
              </form>
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                sx={{ width: 150, height: 40 }}
                onClick={handleResetFilter}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Reset Filter"}
              </BootstrapButton>
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                onClick={handleProcessExport}
                disabled={isLoading}
                style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
              >
                {isLoading ? "Loading..." : "Process"}
              </BootstrapButton>
              <BootstrapButton
                variant="contained"
                disableRipple
                onClick={handleConfirmationExport}
                disabled={isLoading}
                style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
              >
                {isLoading ? "Loading..." : "Download"}
              </BootstrapButton>
            </Grid>
          </Grid>
        </div>

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 650 }}>
            <Table
              aria-label="simple table"
              sx={{
                border: 1,
                borderColor: "grey.300",
                borderCollapse: "collapse",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell style={tableCellStyle} sx={{ border: 1, borderColor: 'grey.300' }}>Province Code</TableCell>
                  <TableCell style={tableCellStyle} sx={{ border: 1, borderColor: 'grey.300' }}>Province Name</TableCell>
                  <TableCell style={tableCellStyle} sx={{ border: 1, borderColor: 'grey.300' }}>Kab/Kota Code</TableCell>
                  <TableCell style={tableCellStyle} sx={{ border: 1, borderColor: 'grey.300' }}>Kab/Kota Name</TableCell>
                  {sortTableCell("Kecamatan Code", "code")}
                  {sortTableCell("Kecamatan Name", "name")}
                  <TableCell style={tableCellStyle} sx={{ border: 1, borderColor: 'grey.300' }}>Aksi</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRows.length > 0 ? (
                  filteredRows.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center" sx={{ border: 1, borderColor: 'grey.300' }}>{row.province_code}</TableCell>
                      <TableCell align="center" sx={{ border: 1, borderColor: 'grey.300' }}>
                        {row.province?.name ||
                          dataProvinces.find(
                            (option) => option.value === selectedProvince
                          )?.label}
                      </TableCell>
                      <TableCell align="center" sx={{ border: 1, borderColor: 'grey.300' }}>{row.regency_code}</TableCell>
                      <TableCell align="center" sx={{ border: 1, borderColor: 'grey.300' }}>
                        {row.regency?.name ||
                          dataRegencies.find(
                            (option) => option.value === selectedRegency
                          )?.label}
                      </TableCell>
                      <TableCell align="center" sx={{ border: 1, borderColor: 'grey.300' }}>{row.code}</TableCell>
                      <TableCell align="center" sx={{ border: 1, borderColor: 'grey.300' }}>{row.name}</TableCell>
                      <TableCell align="center" sx={{ border: 1, borderColor: 'grey.300' }}>
                        <Tooltip
                          title="Edit Data"
                          onClick={() => handleEditClick(row)}
                        >
                          <IconButton>
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ border: 1, borderColor: 'grey.300' }}>
                      {isLoading ? "Loading..." : "No Data Available"}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* pagination */}
          {filteredRows.length > 0 && (
            <TablePagination
              rowsPerPageOptions={itemsPerPageList}
              component="div"
              count={totalItems}
              rowsPerPage={itemsPerPage}
              page={currentPage - 1}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleChangeItemPerPageSelect}
            />
          )}
        </Paper>

        <Modal
          open={editModalOpen}
          onClose={handleCloseEditModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: {
                xs: "90vw",
                sm: 400,
              },
              maxHeight: "90vh",
              bgcolor: "background.paper",
              border: "0px solid #000",
              boxShadow: 24,
              p: {
                xs: 2,
                sm: 4,
              },
              overflowY: "auto",
              borderRadius: 2,
            }}
          >
            <div className="edit-data">
              <h2>Edit Kecamatan</h2>
              <div>
                <Autocomplete
                  options={dataProvinces}
                  getOptionLabel={(option) => option.label}
                  value={
                    dataProvinces.find(
                      (option) => option.value === editedData.province_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setEditedData({
                      ...editedData,
                      province_id: newValue ? newValue.value : "",
                    });
                    setEditedData((prevData) => ({
                      ...prevData,
                      regency_id: "",
                    }));
                  }}
                  sx={{ mb: 2 }}
                  renderInput={(params) => (
                    <TextField {...params} label="PROVINSI" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disableClearable
                />
                <Autocomplete
                  options={dataRegenciesTemp}
                  getOptionLabel={(option) => option.label}
                  value={
                    dataRegenciesTemp.find(
                      (option) => option.value === editedData.regency_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setEditedData({
                      ...editedData,
                      regency_id: newValue ? newValue.value : "",
                    });
                  }}
                  sx={{ mb: 2 }}
                  renderInput={(params) => (
                    <TextField {...params} label="KECAMATAN" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disableClearable
                />
                <TextField
                  name="name"
                  label="Name"
                  sx={{ width: "100%", mb: 2 }}
                  value={editedData.name ?? ""}
                  onChange={(e) =>
                    setEditedData({
                      ...editedData,
                      name: e.target.value,
                    })
                  }
                ></TextField>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="outlined"
                  disableRipple
                  sx={{
                    width: "50%",
                    height: 50,
                    mt: 2,
                    color: "#b34469",
                    borderColor: "#b34469",
                  }}
                  onClick={handleCloseEditModal}
                >
                  Cancel
                </Button>
                <BootstrapButton
                  variant="contained"
                  disableRipple
                  sx={{ width: "50%", height: 50, mt: 2, mr: 0, ml: 2 }}
                  onClick={handleUpdateData}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "UPDATE"}
                </BootstrapButton>
              </div>
            </div>
          </Box>
        </Modal>

        <ModalConfirmation
          open={openDialogConfirmationExport}
          onClose={handleCloseConfirmationExport}
          title={'Konfirmasi Download'}
          confirmationText={'Yes'}
          description={`Ditemukan ${viewDataExport.title} terakhir diproses pada ${viewDataExport.process_at}. Apakah anda yakin ingin download rawdata ini?`}
          isLoading={isLoading}
          handleClick={handleExportResult}
        />
      </div>
    </div>
  );
}

export default SetupBpsDistrict;
